var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getRedPoint.hasRedPoint),expression:"getRedPoint.hasRedPoint"}],class:[_vm.hasNumber ? 'number-point' : 'little-point'],attrs:{"id":"red-point"}},[_vm._v(_vm._s(_vm.hasNumber ? _vm.getRedPoint.redPointNumber : ''))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c332bb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/red-point/red-point.vue
// module id = null
// module chunks = 